import { JDSTagProps } from './generated';
import { useToggle } from '../../hooks/useToggle';

const legacyKinds = ['normal'] as const;
type legacyKindsType = (typeof legacyKinds)[number];

export interface TagProps extends Omit<JDSTagProps, 'onClick' | 'kind'> {
  kind?: legacyKindsType | JDSTagProps['kind'];
  onClick?: (ev: React.MouseEvent<HTMLDivElement>) => void;
}

export const withLogic =
  (Component: React.ComponentType<TagProps>): React.FC<TagProps> =>
  (props: TagProps) => {
    const { selected, toggle } = useToggle<HTMLDivElement>(
      props.active,
      props.kind !== 'normal',
      props.onClick
    );

    return (
      <Component
        {...{
          ...props,
          onClick: toggle,
          active: selected,
          icon: selected ? 'IcClose' : props.icon || 'IcAdd'
        }}
      />
    );
  };
